module.exports = __webpack_public_path__ + "img/play.5a2b69ed.png";